// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"44b4d644","83":"a9a25639","160":"96640e41","208":"ce248dc5","293":"6166edd3","323":"ec3045f4","453":"19575ba0","471":"1dc41641","516":"ca409be3","519":"3ef3956f","587":"7177456f","660":"140b74c5","740":"af9e0a3b","917":"16091d6e","946":"b0c3f6c3"}[chunkId] + ".chunk.js";
};